import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import propTypes from 'prop-types'

import Spinner from '@components/spinner'
import { formatDateTime } from '@atheneum/api/dist/lib'

class ExtractEplsInfoModal extends Component {
  static propTypes = {
    logStore: propTypes.object,
    log: propTypes.object.isRequired
  }
  static defaultProps = {
    hideButtons: true,
    showCloseIcon: true,
    wideContent: true
  }

  constructor (props) {
    super(props)

    const email = props.log.logObjects.find(obj => obj.type === 'email')
    props.logStore.getExtractEplsEmailInfo(email.objectId)
  }

  render () {
    const { loading, eplExtractEmail } = this.props.logStore
    if (loading) return <Spinner />

    const toRecipients = eplExtractEmail.recipients.filter(
      rec => rec.type === 'to'
    )
    const toEmails = toRecipients.map(rec => rec.email).join(', ')

    const ccRecipients = eplExtractEmail.recipients.filter(
      rec => rec.type === 'cc'
    )
    let ccEmails = '-'
    if (ccRecipients.length) {
      ccEmails = ccRecipients.map(rec => rec.email).join(', ')
    }

    return (
      <div>
        <h2>{eplExtractEmail.subject}</h2>
        <hr className='hr-separator hr-separator--light' />
        <div className='details-list'>
          <div>FROM:</div>
          <div>{eplExtractEmail.from.email || '-'}</div>
        </div>
        <div className='details-list'>
          <div>TO:</div>
          <div>{toEmails}</div>
        </div>
        <div className='details-list'>
          <div>CC:</div>
          <div>{ccEmails}</div>
        </div>
        <div className='details-list'>
          <div>Employee:</div>
          <div>{eplExtractEmail.employee.fullName || '-'}</div>
        </div>
        <div className='details-list'>
          <div>Subject:</div>
          <div>{eplExtractEmail.subject || '-'}</div>
        </div>
        <div className='details-list'>
          <div>Sent:</div>
          <div>{formatDateTime(eplExtractEmail.created_at)}</div>
        </div>
        <table className='table-wrapper'>
          <thead>
            <tr>
              <th>Receiver</th>
              <th>Delivered</th>
              <th>Opened</th>
              <th>Clicked</th>
            </tr>
          </thead>
          <tbody>
            {eplExtractEmail.recipients.map(recipient => {
              const deliveredEvent = recipient.events.find(
                e => e.event === 'delivery'
              )
              const openedEvent = recipient.events.find(e => e.event === 'open')
              const clickedEvent = recipient.events.find(
                e => e.event === 'click'
              )
              return (
                <tr key={recipient.id}>
                  <th>{recipient.email}</th>
                  <th>
                    {deliveredEvent
                      ? formatDateTime(deliveredEvent.timestamp)
                      : '-'}
                  </th>
                  <th>
                    {openedEvent ? formatDateTime(openedEvent.timestamp) : '-'}
                  </th>
                  <th>
                    {clickedEvent
                      ? formatDateTime(clickedEvent.timestamp)
                      : '-'}
                  </th>
                </tr>
              )
            })}
          </tbody>
        </table>
        <h2>Content</h2>
        <hr className='hr-separator hr-separator--light' />
        <div
          dangerouslySetInnerHTML={{
            __html: eplExtractEmail.htmlBody
          }}
        />
      </div>
    )
  }
}

export default inject('logStore', 'modalStore')(observer(ExtractEplsInfoModal))
